import axiosPublicClient from "../../../../axiosPublicClient"

export default async (payload) => {
    const result = await axiosPublicClient.post(`/pre-check-candidate-view`, payload)
    return result.data
}
